<div class="team-members-list">
  <app-team-member-card
    *ngFor="let teamMember of teamMembers | async"
    [teamMember]="teamMember"
  ></app-team-member-card>
</div>
